import { ThresholdIndicatorData } from '../../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { getThresholdPixel } from '../../../../core/components/threshold-bar/utils/get-threshold-pixel.ts.js';
import { ThresholdData } from '../../../../core/types/thresholds.js';
import { isStatic } from '../../../../core/types/type-guards.js';
import {
  Layout,
  type CategoricalValueScales,
} from '../../../types/categorical-bar-chart.js';
import { isVertical } from '../../../utils/layout.js';

export const transformThresholdIntoIndicatorByLayout = (
  data: ThresholdData,
  scale: CategoricalValueScales,
  layout: Layout,
  size: number,
): ThresholdIndicatorData[] => {
  const valueMin = getThresholdPixel(
    isStatic(data) ? data.value : data.min,
    scale,
    layout,
  );
  const valueMax = getThresholdPixel(
    isStatic(data) ? data.value : data.max,
    scale,
    layout,
  );

  if (isVertical(layout)) {
    return [
      {
        x0: 0,
        x1: 0,
        y0: valueMin,
        y1: valueMax,
      },
      {
        x0: size,
        x1: size,
        y0: valueMin,
        y1: valueMax,
      },
    ];
  }

  return [
    {
      x0: valueMin,
      x1: valueMax,
      y0: 0,
      y1: 0,
    },
    {
      x0: valueMin,
      x1: valueMax,
      y0: size,
      y1: size,
    },
  ];
};
